/**
 * Waitlist customer capture without a page navigation.
 *
 * Shopify's hCaptcha script intercepts submit, writes h-captcha-response,
 * then calls HTMLFormElement.prototype.submit() — which bypasses
 * preventDefault and navigates to ?customer_posted=true. We:
 *   1. preventDefault so the browser never navigates
 *   2. patch prototype.submit for .sj-waitlist so that last step
 *      becomes a fetch, with the token already in the form
 *   3. redirect: 'manual' so fetch does not follow Shopify's 302 and
 *      download the homepage before we show success
 * https://shopify.dev/docs/storefronts/themes/trust-security/captcha
 */
(function () {
  if (window.sjWaitlistReady) return;
  window.sjWaitlistReady = true;

  var nativeSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    if (this.classList && this.classList.contains('sj-waitlist')) {
      submitWaitlist(this);
      return;
    }
    return nativeSubmit.apply(this, arguments);
  };

  document.addEventListener('submit', onSubmit, true);

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('sj-waitlist')) return;
    event.preventDefault();

    var host = form.closest('sj-waitlist-form');
    var button = form.querySelector('.sj-waitlist__button');
    if (button) button.disabled = true;

    if (!(window.Shopify && Shopify.captcha && Shopify.captcha.protect)) {
      submitWaitlist(form);
      return;
    }

    window.setTimeout(function () {
      if (!form.isConnected) return;
      if (form.getAttribute('aria-busy') === 'true') return;
      fail(host, form, button);
    }, 20000);
  }

  function submitWaitlist(form) {
    if (form.getAttribute('aria-busy') === 'true') return;

    var host = form.closest('sj-waitlist-form');
    var button = form.querySelector('.sj-waitlist__button');
    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;

    var action = (form.getAttribute('action') || '/contact').split('#')[0];

    fetch(action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      redirect: 'manual',
    })
      .then(function (response) {
        if (isShopifyPosted(response)) {
          showSuccess(host, form);
          return;
        }
        return response.text().then(function (html) {
          if (/Missing CAPTCHA token/i.test(html) || !response.ok) {
            fail(host, form, button);
            return;
          }
          showSuccess(host, form);
        });
      })
      .catch(function () {
        fail(host, form, button);
      });
  }

  function isShopifyPosted(response) {
    if (response.type === 'opaqueredirect') return true;
    if (response.status >= 300 && response.status < 400) return true;
    return /[?&](?:customer|contact)_posted=true/.test(response.url);
  }

  function fail(host, form, button) {
    form.removeAttribute('aria-busy');
    if (button) button.disabled = false;
    showMessage(host || form, 'error', decodeCopy(host && host.dataset.error));
  }

  function showSuccess(host, form) {
    var copy = decodeCopy(host && host.dataset.success);
    var root = host || form;
    root.innerHTML = '';
    showMessage(root, 'success', copy);
  }

  function decodeCopy(value) {
    if (!value) return '';
    var textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  function showMessage(root, kind, copy) {
    if (!root || !copy) return;
    var existing = root.querySelector('.sj-waitlist__' + kind);
    if (existing) existing.remove();

    var p = document.createElement('p');
    p.className = 'sj-waitlist__' + kind;
    p.setAttribute('role', kind === 'error' ? 'alert' : 'status');
    p.tabIndex = -1;
    p.textContent = copy;
    root.appendChild(p);
    p.focus({ preventScroll: true });
  }
})();
